import {
  SET_AUTHENTICATED,
  SET_ACCESS_TOKEN,
  GET_NEW_TOKEN,
  SET_REFRESH_TOKEN,
  SET_LOADING_APP,
  SET_POPUP
} from './constants';

export function setAuthenticated(isAuthenticated) {
  return {
    type: SET_AUTHENTICATED,
    isAuthenticated,
  };
}

export function setAccessToken(accessToken) {
  return {
    type: SET_ACCESS_TOKEN,
    accessToken,
  };
}
export function getNewAccessToken(refreshToken, cbFailed) {
  return {
    type: GET_NEW_TOKEN,
    refreshToken,
    cbFailed
  };
}
export function setRefreshToken(refreshToken) {
  return {
    type: SET_REFRESH_TOKEN,
    refreshToken,
  };
}
export function setIsLoading(isLoading) {
    return {
        type: SET_LOADING_APP,
        isLoading
    }
}
export function showPopup(popup) {
    return {
        type: SET_POPUP,
        popup
    }
}



